import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';
import { Box, showSuccessToast, showWarningToast, Text } from 'core/components';
import { Checkbox, Field, FormDialog } from 'core/form';
import AgentSelector from '../components/agentSelector/AgentSelector';

@inject('$syn')
@observer
export default class AgentMigrateFormDialog extends Component {
  onSubmit = (form, values) => {
    const { $syn, refreshDetails } = this.props;
    const replace_geo = form.getValue('replace_geo');
    return $syn.requests
      .migrateAgentTests({ old_agent: form.model.id, new_agent: values.agent, replace_geo })
      .then((resp = {}) => {
        const { new_agent, old_agent, error_msg = null } = resp;
        if (!error_msg) {
          showSuccessToast(`Agent ${old_agent} was updated successfully with data from ${new_agent}.`, {
            title: 'Agent was successfully updated',
            timeout: 6000
          });
        } else {
          showWarningToast(`${error_msg}. Agent ${old_agent} was not updated with data from ${new_agent}.`, {
            title: 'There was a problem updating this agent',
            timeout: 6000
          });
        }
        return $syn.agents.fetch({ force: true }).then(() => refreshDetails());
      });
  };

  render() {
    const { onClose, model, ...rest } = this.props;
    const agent_alias = model.get('agent_alias');
    const fields = {
      agent: {
        rules: ['required', `not_in:${model.id}`],
        messages: { required: 'One agent selections is required' }
      },
      replace_geo: {
        defaultValue: false,
        label: 'Use pending agent country, region and city'
      }
    };
    return (
      <FormDialog
        {...rest}
        model={model}
        fields={fields}
        options={{ name: 'Synthetic Agent Migrate Form' }}
        title={`Update Tests Using ${agent_alias} (${model.id}) to New Agent`}
        isOpen
        onClose={onClose}
        formActionsProps={{
          confirmSubmit: true,
          confirmBodyContent: (
            <Text>
              Please confirm you would like to update{' '}
              <Text fontWeight="heavy">
                {agent_alias} ({model.id})
              </Text>{' '}
              with data from selected agent?
            </Text>
          ),
          onSubmit: this.onSubmit,
          onCancel: onClose,
          submitButtonText: 'Submit'
        }}
        width={720}
      >
        <Box overflow="auto" height={500}>
          <Field name="agent" large mb={0} showError={false}>
            <AgentSelector
              // TODO: deprecate browserAgents #7660
              hideNetworkAgents={model.isBrowser}
              hidePrivateAgents
              hideGlobalAgents
              showPendingAgents
              inlineForm
              multi={false}
              required
              showIdColumn
            />
          </Field>
          <Field name="replace_geo" showLabel={false} mt={2}>
            <Checkbox />
          </Field>
        </Box>
      </FormDialog>
    );
  }
}
